import { render, staticRenderFns } from "./OldMutualProtectConfirm.vue?vue&type=template&id=4a41dd15"
import script from "./OldMutualProtectConfirm.vue?vue&type=script&lang=js"
export * from "./OldMutualProtectConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports